// extracted by mini-css-extract-plugin
export default {"wrapper":"Main_wrapper__TBk6r","settings-content-wrapper":"Main_settings-content-wrapper__E5Av9"};